import Vue from 'vue'

export default {
  setWhitelists: (state, value) => {
    state.whitelists = value
  },
  addWhitelist: (state, value) => {
    const exists = state.whitelists.some(info => {
      return info.ID === value.ID
    })
    if (!exists) {
      state.whitelists.push(value)
    }
  },
  setWhitelist: (state, value) => {
    if (value && value.Zones.length) {
      value.Zones = value.Zones.slice(1, -1).split('|')
    }
    state.whitelist = value
  },
  setWhitelistInWhitelistsArray: (state, payload) => {
    const existingWhitelist = state.whitelists.find(
      whitelist => whitelist.ID === payload.ID
    )
    Object.assign(existingWhitelist, payload)
  },
  setCurrentWhitelistUsers: (state, value) => {
    Vue.set(state.whitelist, 'Users', value.value)
  },
  addUserToWhitelist: (state, user) => {
    if (user.ID) {
      const whitelistUserIndex = state.whitelist.Users.findIndex(
        whitelistUser => whitelistUser.ID === user.ID
      )
      if (!whitelistUserIndex) {
        state.whitelist.Users.push(user)
      }
      if (whitelistUserIndex === -1) {
        state.whitelist.Users.push(user)
      }
    } else {
      state.whitelist.Users.push(user)
    }
  },
  removeWhitelistUser: (state, payload) => {
    const whitelistUserIndex = state.whitelist.Users.findIndex(
      user => user.ID === payload.ID
    )
    state.whitelist.Users.splice(whitelistUserIndex, 1)
  },
  updateWhitelistUser: (state, payload) => {
    const index = state.whitelist.Users.findIndex(
      user => user.ID === payload.ID
    )
    if (index !== -1) {
      Vue.set(state.whitelist.Users, index, payload)
    }
  },
  removeWhitelistById: (state, whitelistId) => {
    const whitelistIndex = state.whitelists.findIndex(
      wl => wl.ID === whitelistId
    )
    state.whitelists.splice(whitelistIndex, 1)
  },
  setCurrentWhitelistId: (state, value) => {
    state.currentWhitelistId = value
  },
  setAvailabilityInfo: (state, value) => {
    state.availabilityInfo = value
  },
  addAvailabilityInfo: (state, value) => {
    const exists = state.availabilityInfo.some(info => {
      return info.ID === value.ID
    })
    if (!exists) {
      state.availabilityInfo.push(value)
    }
  },
  /**
   * Sets specified key value on whitelist Object
   * @param {Object} object - { key: 'Name', value: 'Test Name Value' }
   */
  setWhitelistValue: (state, data) => {
    Vue.set(state.whitelist, data.key, data.value)
  },
  /**
   * Sets specified key value on whitelist AvailabilityTable Object
   * @param {Object} object - { key: 'Name', value: 'Test Name Value' }
   */
  setWhitelistAvailabilityTableValue: (state, data) => {
    Vue.set(state.whitelist.AvailabilityTable, data.key, data.value)
  },
  /**
   * Sets specified key value on whitelist DiscountPlan Object
   * @param {Object} object - { key: 'Name', value: 'Test Name Value' }
   */
  setWhitelistDiscountPlanValue: (state, data) => {
    Vue.set(state.whitelist.DiscountPlan, data.key, data.value)
  },
  removeManagerFromWhitelistManagersArray: (state, data) => {
    const whitelistManagerIndex = state.whitelist.Managers.findIndex(
      user => user.OwnerId === data.OwnerId
    )
    state.whitelist.Managers.splice(whitelistManagerIndex, 1)
  },
  setNextAvailablePage: (state, value) => {
    state.nextAvailablePage = value
  },
  setWhitelistsLoaded: (state, value) => {
    state.whitelistsLoaded = value
  },
  setCurrentPage: (state, value) => {
    state.currentPage = value
  },
  setPageSize: (state, value) => {
    state.pageSize = value
  }
}
